export default __webpack_public_path__ + "static/media/fastFood05.d464de48.png";